import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-close\"><path fill-rule=\"evenodd\" d=\"M13.649 12l8.29-9.598c.14-.16.023-.402-.192-.402h-2.52a.521.521 0 00-.389.175L12 10.092 5.162 2.175A.51.51 0 004.773 2h-2.52c-.215 0-.332.242-.193.402L10.351 12l-8.29 9.598a.238.238 0 00-.037.261c.041.086.13.141.229.141h2.52c.149 0 .291-.064.389-.175L12 13.908l6.838 7.917c.095.11.237.175.389.175h2.52c.215 0 .332-.242.193-.402L13.649 12z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol